// 📁 frontend/src/sezioni/MessaggiNuovo.js
// Vista form nuova comunicazione.
import React, { useRef, useState } from "react";
import { api } from "../api/client";

const ALLOWED_MIME = [
  "application/pdf",
  "image/jpeg", "image/jpg", "image/png",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "video/mp4",
];
const MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;

function formatBytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

function buildHeaders(user) {
  const h = {
    "X-Session-Token": user.token,
    "X-User-Id": String(user.id),
  };
  if (user.assunzione_id) h["X-Assunzione-Id"] = String(user.assunzione_id);
  if (user.azienda_id)    h["X-Azienda-Id"]    = String(user.azienda_id);
  return h;
}

export default function MessaggiNuovo({ user, categorie, onCreated, onCancel }) {
  const [categoriaId, setCategoriaId] = useState("");
  const [testo, setTesto] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  function pickFile(e) {
    setError(null);
    const f = e.target.files?.[0];
    if (!f) { setFile(null); return; }
    if (f.size > MAX_ATTACHMENT_BYTES) { setError("File troppo grande (max 5 MB)"); fileRef.current.value = ""; return; }
    if (!ALLOWED_MIME.includes(f.type)) { setError("Tipo file non ammesso"); fileRef.current.value = ""; return; }
    setFile(f);
  }

  async function submit() {
    if (!categoriaId) { setError("Seleziona una categoria"); return; }
    if (!testo.trim()) { setError("Scrivi un testo"); return; }
    setBusy(true); setError(null);
    try {
      const r = await api.post(
        "/api/chat/threads",
        { categoria_id: Number(categoriaId), testo: testo.trim() },
        { headers: buildHeaders(user) }
      );
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        await api.postForm(`/api/chat/messages/${r.message_id}/attachments`, fd, { headers: buildHeaders(user) });
      }
      onCreated(r.thread_id);
    } catch (err) {
      setError(err.message || "Errore creazione");
      setBusy(false);
    }
  }

  return (
    <div
      className="bg-white rounded-xl shadow-lg p-4 max-w-2xl mx-auto mt-4 w-full flex flex-col"
      style={{ minHeight: "calc(100dvh - 5rem)" }}
    >
      <div className="text-lg font-bold text-primary mb-4">Nuova comunicazione</div>

      <label className="block text-sm font-bold text-primary mb-1">Categoria *</label>
      <select
        value={categoriaId}
        onChange={(e) => setCategoriaId(e.target.value)}
        className="w-full border rounded-lg px-3 py-2 mb-4 text-base"
      >
        <option value="">Seleziona…</option>
        {categorie.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
      </select>

      <label className="block text-sm font-bold text-primary mb-1">Testo *</label>
      <textarea
        value={testo}
        onChange={(e) => setTesto(e.target.value)}
        rows={5}
        className="w-full border rounded-lg px-3 py-2 mb-4 text-base"
        placeholder="Scrivi il messaggio per l'ufficio HR…"
      />

      <label className="block text-sm font-bold text-primary mb-1">
        Allegato <span className="font-normal text-gray-500">(opzionale, max 5 MB)</span>
      </label>
      <input
        ref={fileRef}
        type="file"
        onChange={pickFile}
        accept={ALLOWED_MIME.join(",")}
        className="block text-base mb-2 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blu-uss hover:file:bg-blue-100"
      />
      {file && (
        <div className="text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 mb-2 flex items-center justify-between gap-2">
          <span className="truncate">📎 {file.name} <span className="text-gray-500">({formatBytes(file.size)})</span></span>
          <button onClick={() => { setFile(null); fileRef.current.value = ""; }} className="text-red-600 font-bold px-1">✕</button>
        </div>
      )}

      {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-3">{error}</div>}

      <div className="flex gap-3 mt-auto pt-4">
        <button
          onClick={onCancel}
          disabled={busy}
          className="flex-1 border-2 border-gray-300 text-gray-700 rounded-xl py-3 font-bold hover:bg-gray-50 transition"
        >
          Annulla
        </button>
        <button
          onClick={submit}
          disabled={busy}
          className="flex-1 bg-blu-uss text-white rounded-xl py-3 font-bold disabled:opacity-50 hover:opacity-90 transition shadow"
        >
          {busy ? "Invio…" : "Invia"}
        </button>
      </div>
      {/* Spacer per home indicator iOS */}
      <div className="h-16" />
    </div>
  );
}
